import styled from "styled-components";

export const LineChartBox = styled.div`
  /* width: 100%;
  height: 100%;

  .echarts-for-react {
    & > div {
      height: 100% !important;
    }
  } */

  width: 100%;
  height: 100%;

  .echarts-for-react {
    height: 100% !important;

    & > div:first-child {
      height: 100% !important;
    }
  }
`;
